import type { ISerialize } from '@/objects/ISerialize';

export class MapPoint implements ISerialize {
    public Accuracy: number;

    public Altitude: number | null;

    public BearingDegrees: number;

    public DistanceFromPreviousPoint: number | null;

    public DistanceFromStart: number | null;

    public Latitude: number;

    public Longitude: number;

    public Speed: number;

    public UTCTime: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Accuracy?: number;
        Altitude?: number | null;
        BearingDegrees?: number;
        DistanceFromPreviousPoint?: number | null;
        DistanceFromStart?: number | null;
        Latitude?: number;
        Longitude?: number;
        Speed?: number;
        UTCTime?: number;
    }) {
        this.Accuracy = values.Accuracy ?? 0;

        this.Altitude = values.Altitude ?? null;

        this.BearingDegrees = values.BearingDegrees ?? 0;

        this.DistanceFromPreviousPoint = values.DistanceFromPreviousPoint ?? null;

        this.DistanceFromStart = values.DistanceFromStart ?? null;

        this.Latitude = values.Latitude ?? 0;

        this.Longitude = values.Longitude ?? 0;

        this.Speed = values.Speed ?? 0;

        this.UTCTime = values.UTCTime ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"Accuracy": ${JSON.stringify(this.Accuracy)}` +
            ',' +
            `"Altitude": ${JSON.stringify(this.Altitude)}` +
            ',' +
            `"BearingDegrees": ${JSON.stringify(this.BearingDegrees)}` +
            ',' +
            `"DistanceFromPreviousPoint": ${JSON.stringify(this.DistanceFromPreviousPoint)}` +
            ',' +
            `"DistanceFromStart": ${JSON.stringify(this.DistanceFromStart)}` +
            ',' +
            `"Latitude": ${JSON.stringify(this.Latitude)}` +
            ',' +
            `"Longitude": ${JSON.stringify(this.Longitude)}` +
            ',' +
            `"Speed": ${JSON.stringify(this.Speed)}` +
            ',' +
            `"UTCTime": ${JSON.stringify(this.UTCTime)}` +
            '}'
        );
    }

    /**
     * Creates an instance of MapPoint from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Accuracy?: number;
        Altitude?: number | null;
        BearingDegrees?: number;
        DistanceFromPreviousPoint?: number | null;
        DistanceFromStart?: number | null;
        Latitude?: number;
        Longitude?: number;
        Speed?: number;
        UTCTime?: number;
    }): MapPoint {
        return new MapPoint(values);
    }

    public static _FromServerJson(json: any): MapPoint {
        return new MapPoint({
            Accuracy: json.Accuracy,
            Altitude: json.Altitude ?? null,
            BearingDegrees: json.BearingDegrees,
            DistanceFromPreviousPoint: json.DistanceFromPreviousPoint ?? null,
            DistanceFromStart: json.DistanceFromStart ?? null,
            Latitude: json.Latitude,
            Longitude: json.Longitude,
            Speed: json.Speed,
            UTCTime: json.UTCTime,
        });
    }

    /**
     * Creates an instance of MapPoint from another instance of MapPoint.
     * @param other The MapPoint you want to clone
     * @returns A cloned MapPoint
     */
    public static FromOther(other: MapPoint): MapPoint {
        return MapPoint._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return MapPoint.FromOther(this);
    }

    static NAME_OF_CLASS = 'MapPoint';
}
